/* eslint-disable camelcase */
import React from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { toast } from 'react-toastify';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import { useParams, useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

import { deletePatient } from '../store/actions/patients';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 18,
    margin: 0,
    color: '#1e3f9e',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '90%',
  },
  paper: {
    padding: '2rem',
    paddingTop: '1rem',
    minWidth: 550,
    maxWidth: '700px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  sectionHead: {
    width: '100%',
    borderBottom: 'solid 2px gray',
    color: 'gray',
  },
  buttonRow: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '2rem',
    width: '100%',
    justifyContent: 'space-around',
  },
  button: {
    width: '20%',
    margin: '-1rem 0 1rem 0',
    padding: '0.6rem',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
  form: {
    margin: '1rem 0 -1rem 0',
    width: '100%',
    display: 'flex',
    flexFlow: 'row wrap',
  },
}));

const DeletePatientModal = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();

  const handleClose = () => {
    setOpen(false);
  };

  // TODO:
  // 1. if there is a device on a user, remove that device
  // and then delete the user
  const handleSubmit = () => {
    dispatch(deletePatient(id));
    history.push(`../patients`);
    toast.success('Patient successfully removed. Refresh the page if you do not see changes immediately.', {
      position: 'bottom-left',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      theme: 'colored',
    });
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <h2 className={classes.title}>Remove Patient</h2>
          <form className={classes.form} onSubmit={handleSubmit}>
            <div className={classes.sectionHead} />
            <h3 className={classes.title}>
              You are about to remove this patient from the Neuralert program. Do you wish to continue? Any monitors
              attached to this patient will be unlinked.
            </h3>
            <div className={classes.buttonRow}>
              <Button className={classes.button} size="small" variant="contained" onClick={handleClose}>
                No
              </Button>
              <Button className={classes.button} size="small" variant="contained" type="submit" onClick={handleSubmit}>
                Yes
              </Button>
            </div>
          </form>
        </div>
      </Fade>
    </Modal>
  );
};

DeletePatientModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default DeletePatientModal;
